import { Modal } from 'antd';

export const CustomNotificationModal = ({
  type = 'info', // Can be 'info', 'success', 'error', 'warning'
  title = 'Notification',
  children, // Supports HTML/JSX content
  onOk,
  ...props
}) => {
  // Open the corresponding Ant Design modal type
  const showModal = () => {
    Modal[type]({
      title,
      content: children,
      onOk,
      ...props,
    });
  };

  return showModal();
};